module.exports = __webpack_public_path__ + "img/section2b_2.03ce9cdd.png";